<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">Nobly, nobly Cape Saint Vincent to the North-west died away;</span></p>
<p class="p4"><span class="sz">Sunset ran, one glorious blood-red, reeking into Cadiz Bay:</span></p>
<p class="p4"><span class="sz">Bluish mid the burning water, full in face Trafalgar lay;</span></p>
<p class="p4"><span class="sz">In the dimmest North-east distance, dawned Gibraltar grand and grey;</span></p>
<p class="p4"><span class="sz">‘Here and here did England help me: how can I help England?’—say,</span></p>
<p class="p4"><span class="sz">Whoso turns as I, this evening, turn to God to praise and pray,</span></p>
<p class="p4"><span class="sz">While Jove’s planet rises yonder, silent over Africa.</span></p>
<p class="p5"><span class="sz">—R. Browning</span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">The present state of Gibraltar is contrary to the whole spirit of post-war Europe,</span></p>
<p class="p5"><span class="sz">—General Franco</span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p6"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?df30a294